import React from 'react';
import { flexRender, HeaderGroup, SortingState } from '@tanstack/react-table';
import { TableHeaderCell } from '@experiences/components/table/table-header-cell';
import { TableHeaderRow } from '@experiences/components/table/table-header-row';
import { Typography } from '@usepepper/ui/atoms/typography';
import { ViewStyle } from 'react-native';

interface Props<TData> {
  headerCellStyle: ViewStyle;
  headerGroup: HeaderGroup<TData>;
  isLeftAlignedColumn: (columnId: string) => boolean;
  /**
   * Read through `header.column.getIsSorted()`, not from this prop; it is
   * here so the memo re-renders when the sort changes.
   */
  sorting: SortingState;
}

// Memoized so an override, which re-renders the screen, doesn't re-render
// every header cell and its tooltip with it.
const AgentTableHeaderCellsImpl = <TData,>({
  headerCellStyle,
  headerGroup,
  isLeftAlignedColumn,
}: Props<TData>) => (
  <TableHeaderRow>
    {headerGroup.headers.map((header) => (
      <TableHeaderCell
        columnId={header.id}
        key={header.id}
        onPress={
          header.column.getCanSort()
            ? () => header.column.toggleSorting()
            : undefined
        }
        pinnedOffset={
          header.column.getIsPinned()
            ? header.column.getStart('left')
            : undefined
        }
        sortDirection={header.column.getIsSorted() || undefined}
        style={isLeftAlignedColumn(header.id) ? undefined : headerCellStyle}
      >
        {header.isPlaceholder ? null : (
          <Typography
            textAlign={isLeftAlignedColumn(header.id) ? undefined : 'right'}
            variant="paragraph-sm-600"
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </Typography>
        )}
      </TableHeaderCell>
    ))}
  </TableHeaderRow>
);

export const AgentTableHeaderCells = React.memo(
  AgentTableHeaderCellsImpl,
) as typeof AgentTableHeaderCellsImpl;
